import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { palette } from 'styled-tools';

import { fontSize, FontSizes, fontWeight, FontWeights, minWidth } from '@calm-web/design-system';

import GridWrapper from '@/components/ui/GridWrapper';
import Checkmark from 'icons/circle-check.svg';

import messages from './messages';

const PremiumSection = styled.div`
	color: white;
	background: linear-gradient(45deg, rgba(121, 59, 235, 0.5) 0%, rgba(121, 59, 235, 0) 100%),
		linear-gradient(180deg, #3bbeec 0%, #3478dd 100%);
	width: auto;

	padding: 32px 20px;

	${minWidth('mobileLarge')} {
		padding: 52px 20px;
	}

	${minWidth('tablet')} {
		padding: 72px 40px;
	}

	${minWidth('desktop')} {
		padding: 92px 40px;
	}
`;

const Title = styled.div`
	text-align: center;
	grid-column: 1 / -1;

	font-size: 24px;
	line-height: 2.25rem;

	${minWidth('mobileLarge')} {
		font-size: 31.5px;
		line-height: 2.625rem;
	}

	${minWidth('tablet')} {
		font-size: 34px;
		line-height: 61px;
	}
`;

const Points = styled.div``;

const Point = styled.div`
	display: flex;
	align-items: top;
	margin-bottom: 26px;
`;

const PointCheckmark = styled(Checkmark)`
	width: 28px;
	height: 28px;
	min-width: 28px;
	path {
		fill: ${palette('accessibleBrandGradient')};
	}
`;

const PointCopy = styled.span`
	${fontSize(FontSizes.base)};
	line-height: 1.5rem;
	${fontWeight(FontWeights.Light)};
	text-align: left;
	margin-left: 12px;

	${minWidth('tablet')} {
		font-size: 22.5px;
		line-height: 33.75px;
	}
`;

const colOne = [messages.premiumReasonOne, messages.premiumReasonTwo, messages.premiumReasonThree];

const colTwo = [messages.premiumReasonFour, messages.premiumReasonFive, messages.premiumReasonSix];

const Premium = () => {
	const { formatMessage } = useIntl();
	return (
		<PremiumSection>
			<GridWrapper columns={2}>
				<Title>{formatMessage(messages.premiumTitle)}</Title>
				<div>
					<Points>
						{colOne.map(point => (
							<Point key={point.id}>
								<PointCheckmark />
								<PointCopy>{formatMessage(point)}</PointCopy>
							</Point>
						))}
					</Points>
				</div>
				<div>
					<Points>
						{colTwo.map(point => (
							<Point key={point.id}>
								<PointCheckmark />
								<PointCopy>{formatMessage(point)}</PointCopy>
							</Point>
						))}
					</Points>
				</div>
			</GridWrapper>
		</PremiumSection>
	);
};

export default Premium;
